var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-column",style:(_vm.topologyHeight)},[_c('div',{staticClass:"flex-fill"},[_c('preview',{on:{"topoJump":_vm.topoJump}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }